import { render } from "./UserIcon.vue?vue&type=template&id=9ac66058&scoped=true"
import script from "./UserIcon.vue?vue&type=script&lang=js"
export * from "./UserIcon.vue?vue&type=script&lang=js"

import "./UserIcon.vue?vue&type=style&index=0&id=9ac66058&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ac66058"]])

export default __exports__